module.exports = __webpack_public_path__ + "static/media/spinner_gear.c84bf65d.svg";